import { animations } from 'theme';

export const styles = {
  bottomRow: {
    borderTop: '1px solid #c5d0de',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#354052',
  },
  contentRow: {
    color: '#354052',
    ...animations.appearanceEffect,
  },
  descriptionRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#7f8fa4',
  },
  value: {
    marginLeft: '10px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    color: '#354052',
    fontSize: '32px',
  },
  units: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#354052',
    marginTop: '15px',
    marginLeft: '3px',
  },
  rightColumn: {
    marginLeft: '8px',
  },
  rightColumnRow: {
    borderBottom: '1px solid #c5d0de',
  },
  valueAndUnitWrapper: {
    marginRight: '5px',
  },
  rightColumnRowValueSubRowItemUnits: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#354052',
    marginTop: '5px',
  },
  rightColumnRowValueSubRowItemValue: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    color: '#354052',
    marginRight: '5px',
  },
  rightColumnRowDescriptionSubRow: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    color: '#7f8fa4',
  },
};
